type GraphQLMetaPropName = "__typename" | " $fragmentRefs" | " $fragmentName";

export function omitGraphQLMetaProps<T extends object>(props: T): Omit<T, GraphQLMetaPropName> {
  const {
    __typename: _typename,
    " $fragmentRefs": _fragmentRefs,
    " $fragmentName": _fragmentName,
    ...rest
  } = props as T & {
    __typename?: unknown;
    " $fragmentRefs"?: unknown;
    " $fragmentName"?: unknown;
  };

  return rest;
}
